// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bev_a bii_rj bii_rk bii_vh bii_eb bii_vf bii_gs bii_kh"};